var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v("\n  COPYRIGHT (C) 2006 National Institute of Health Sciences ALL RIGHTS\n")])}
var staticRenderFns = []

export { render, staticRenderFns }